import { FC } from 'react'

import {
  CirclePersonLineIcon,
  IdCardLineIcon,
  PencilLineIcon
} from '@inno-ui/icons'
import { motion } from 'motion/react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { FEATURE_FLAGS } from 'shared/constants/featureFlags'
import { useExternalLoginStore } from 'shared/stores/externalLoginStore'

import { DateTime } from '../DateTime'
import { HeaderLink } from '../HeaderLink'
import styles from './AuthTemplateHeader.module.scss'
import { AuthTemplateHeaderProps } from './AuthTemplateHeader.types'
import clusterixLogoWhite from '/public/clusterix-logo-white.svg'

export const AuthTemplateHeader: FC<AuthTemplateHeaderProps> = ({
  showHeaderButtons,
  hasSelectableUsers
}) => {
  const { t } = useTranslation('auth')
  const { isExternal } = useExternalLoginStore()

  return (
    <motion.header
      className={styles.header}
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -100, opacity: 0 }}
      transition={{
        type: 'spring',
        stiffness: 400,
        damping: 40,
        delay: 0.2
      }}
    >
      <Link to='/' className={styles.logo}>
        <img src={clusterixLogoWhite} alt='Clusterix Logo' />
      </Link>
      <div className={styles.dateTime}>
        <DateTime />
      </div>
      {showHeaderButtons && (
        <div className={styles.links}>
          {hasSelectableUsers && (
            <HeaderLink
              to='/user-select'
              icon={CirclePersonLineIcon}
              label={t('select_user.title')}
            />
          )}
          <HeaderLink
            to='/login'
            icon={IdCardLineIcon}
            label={t('new_login.title')}
          />
          {FEATURE_FLAGS.REGISTER && !isExternal && (
            <HeaderLink
              to='/register'
              icon={PencilLineIcon}
              label={t('register.title')}
            />
          )}
        </div>
      )}
    </motion.header>
  )
}
